import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getProject } from '../../../api/project.api';
import { setAllProject, deleteProjectReducer } from '../../../Redux/Project/projectAction';

import { Project } from '../../../model/project.model';
import GenericInfo, { InfoField } from '../../adminScreen/GenericInfo';
import { updateProject, deleteProject } from '../../../api/project.api';
import { updateProjectReducer } from '../../../Redux/Project/projectAction'
// import {updateProjectReducer}


interface Props {
  project: Project;
  refreshProjects: () => Promise<void>
  onClose?: () => void

}

const ProjectDetails: React.FC<Props> = ({ project, refreshProjects, onClose }) => {
  const [currentProject, setCurrentProject] = useState<Project | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [allProjects, setallProjects] = useState<Project[]>([]);
  const projectReducer = useSelector((state: { Project: { allProject: { [key: string]: Project[] } } }) => state.Project);
  const [projects, setProjects] = useState<Project[]>([]);

  // const allProjects = useSelector(
  //   (state: { Project: { allProject: Project[] } }) => state.Project.allProject
  // );
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        let dataProject;
        if (projectReducer.allProject.length) {
          dataProject = allProjects;
        } else {
          const response = await getProject();
          dispatch(setAllProject(response.data));
          dataProject = response.data;
        }
        setallProjects(dataProject);
        setProjects(dataProject);
        setCurrentProject(project); // ← זו השורה החסרה
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    fetchProjects(); // ← זו הייתה ממוקמת שגוי גם, לא בתוך הפונקציה
  }, [dispatch, project]);


  const formatDateForDisplay = (date: Date | string | undefined | null) => {
    if (!date) return '';
    const d = new Date(date);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('he-IL');
  };

  const handleFieldsUpdate = (updatedFields: InfoField[]) => {
    if (!currentProject) return;

    const updated = { ...currentProject };

    updatedFields.forEach((field) => {
      if (!field.fieldName) return;

      const keys = field.fieldName.split('.');

      if (keys.length === 1) {
        updated[keys[0]] = field.value;
      } else if (keys.length === 2) {
        const [parentKey, childKey] = keys;

        if (['status', 'balanceStatus', 'stageStatus'].includes(parentKey)) {
          updated[parentKey] = {
            ...(currentProject[parentKey] ?? {}),
            [childKey]: field.value,
            id: currentProject[parentKey]?.id || '' // שמור את ה-id המקורי
          };
        } else {
          updated[parentKey] = {
            ...(currentProject[parentKey] ?? {}),
            [childKey]: field.value,
          };
        }
      }
    });

    setCurrentProject(updated);
  };


  const onSubmit = async (updatedData: Partial<Project>) => {
    if (!currentProject) return;

    try {
      onClose()
      const processedData: Partial<Project> = {
        ...updatedData,
        createdAt: updatedData.createdAt ? new Date(updatedData.createdAt) : currentProject.createdAt,
        updatedAt: new Date(), // תמיד תאריך נוכחי
        endDate: new Date(updatedData.endDate || currentProject.endDate),
        totalPrice: parseFloat((updatedData.totalPrice as any)?.toString()?.replace(/[^\d.-]/g, '') || currentProject.totalPrice.toString()),
        pricePaid: parseFloat((updatedData.pricePaid as any)?.toString()?.replace(/[^\d.-]/g, '') || currentProject.pricePaid.toString()),
        balance: parseFloat((updatedData.balance as any)?.toString()?.replace(/[^\d.-]/g, '') || (currentProject.totalPrice - currentProject.pricePaid).toString()),
      };

      const updatedProject = {
        ...currentProject, // שמור את הקיים
        ...processedData,  // שדרג מה שהשתנה
      };
      console.log('🚨 Going to send to backend:', updatedProject);

      const result = await updateProject(updatedProject);
      setCurrentProject(result.data);
      dispatch(updateProjectReducer(result.data));

      Swal.fire('עודכן', 'הפרויקט עודכן בהצלחה', 'success');

      const updatedP = projects.map(p =>
        p.projectId === result.data.projectId ? result.data : p
      );
      dispatch(setAllProject(updatedP));
      refreshProjects();
    } catch (err) {
      console.error('Error updating project:', err);
      Swal.fire('שגיאה', 'אירעה שגיאה בעדכון הפרויקט', 'error');
    }
  };


  const handleDeleteProject = (projectId: string) => {
    onClose()
    Swal.fire({
      title: 'האם אתה בטוח שברצונך למחוק?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'כן, מחק!',
      cancelButtonText: 'בטל'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          dispatch(deleteProjectReducer(projectId));
          await deleteProject(projectId);
          refreshProjects()
          Swal.fire(
            'נמחק!',
            `הפרויקט עם המזהה ${projectId} נמחק בהצלחה.`,
            'success'
          );

        } catch (error) {
          console.error('Error deleting project:', error);
          Swal.fire(
            'שגיאה!',
            'אירעה שגיאה במחיקת הפרויקט.',
            'error'
          );
        }
      }
    });
  };

  if (!currentProject) return null;

  const fields: InfoField[] = [
    { label: 'שם פרטי', fieldName: 'firstName', value: currentProject.firstName, editType: 'text' },
    { label: 'שם משפחה', fieldName: 'lastName', value: currentProject.lastName, editType: 'text' },
    { label: 'שם העסק', fieldName: 'businessName', value: currentProject.businessName, editType: 'text' },
    { label: 'אימייל', fieldName: 'email', value: currentProject.email, editType: 'text' },
    { label: 'טלפון', fieldName: 'phone', value: currentProject.phone ?? '—', editType: 'text' },
    { label: 'כתובת', fieldName: 'address', value: currentProject.address ?? '—', editType: 'text' },
    { label: 'סטטוס פרויקט', fieldName: 'status.value', value: currentProject.status?.value ?? '—', editType: 'text' },
    { label: 'סטטוס יתרה', fieldName: 'balanceStatus.value', value: currentProject.balanceStatus?.value ?? '—', editType: 'text' },
    { label: 'סטטוס שלב', fieldName: 'stageStatus.value', value: currentProject.stageStatus?.value ?? '—', editType: 'text' },
    { label: 'תאריך יצירה', fieldName: 'createdAt', value: currentProject.createdAt, editType: 'date' },
    { label: 'תאריך עדכון', fieldName: 'updatedAt', value: currentProject.updatedAt, editType: 'date' },
    { label: 'תאריך סיום', fieldName: 'endDate', value: currentProject.endDate, editType: 'date' },
    { label: 'סוג פרויקט', fieldName: 'projectType', value: currentProject.projectType, editType: 'text' },
    { label: 'סה״כ מחיר', fieldName: 'totalPrice', value: `${currentProject.totalPrice} ₪`, editType: 'text' },
    { label: 'שולם', fieldName: 'pricePaid', value: `${currentProject.pricePaid} ₪`, editType: 'text' },
    { label: 'יתרה', fieldName: 'balance', value: `${currentProject.balance} ₪`, editType: 'text' },
    {
      label: 'קישור לפיגמה',
      fieldName: 'urlFigma',
      value: currentProject.urlFigma || '—',
      editType: 'text'
    },
    {
      label: 'קישור לדרייב',
      fieldName: 'urlDrive',
      value: currentProject.urlDrive || '—',
      editType: 'text'
    },
    {
      label: 'קישור לוורדפרס',
      fieldName: 'urlWordpress',
      value: currentProject.urlWordpress || '—',
      editType: 'text'
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <GenericInfo
        title={`פרויקט: ${currentProject.businessName ?? ''}`}
        fields={fields}
        // freeText={currentProject.freeText}
        id={project.projectId}
        onSubmit={onSubmit}
        onFieldsUpdate={handleFieldsUpdate}
        onDelete={handleDeleteProject}
        columns={4} 
      />
    </div>
  );
};

export default ProjectDetails;